<app-uni-page
  [parent]="this"
  *ngIf="isPageReady"
  pageTitle="References: Features"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>
<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-list-actions">
          <div class="flex items-center gap-2">
            <button [disabled]="!this.user.isProductAdmin" pButton type="button" class="p-button-raised p-button-sm" (click)="editFeature()">
              <span>Add Feature</span>
            </button>
          </div>
          <div class="flex items-center">
            <p-checkbox [(ngModel)]="shouldShowInactive" [binary]="true" [disabled]="populateCoreChoices" (ngModelChange)="refreshFeatures()" inputId="shouldShowInactive">
            </p-checkbox>
            <label for="shouldShowInactive" class="ml-2">Show Inactive Items</label>
          </div>
        </div>
        <div class="w-1/2 grow">
          <app-ag-grid
            [gridOptions]="featureGridOptions"
            [hasColSizeButtons]="false"
            [hasClearFiltersButton]="false"
            [rowData]="features"
            class="flex-1 min-h-0"
          ></app-ag-grid>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <p-tabView (onChange)="onTabChanged($event)" class="h-full w-full uni-tabview" styleclass="h-full">
          <p-tabPanel header="Feature Choices">
            <p-splitter class="grow w-full" layout="horizontal" styleClass="h-full" [panelSizes]="[50, 50]">
              <ng-template pTemplate>
                <div class="flex flex-col w-full h-full overflow-hidden">
                  <div class="qb-child-actions">
                    <div class="flex items-center gap-4">
                      <div class="flex items-center gap-2">
                        <p-checkbox
                          [disabled]="!user.isProductAdmin"
                          inputId="allowCombination"
                          [(ngModel)]="allowCombination"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onAllowCombinationChange()"
                          [binary]="true"
                        >
                        </p-checkbox>
                        <label for="allowCombination">Allow Combination / Toggle Status</label>
                      </div>
                      <div class="flex items-center gap-2">
                        <p-checkbox
                          [disabled]="!user.isProductAdmin"
                          inputId="populateCoreChoices"
                          [(ngModel)]="populateCoreChoices"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onPopulateCoreChoicesChange()"
                          [binary]="true"
                        >
                        </p-checkbox>
                        <label for="populateCoreChoices">Populate Core Feature Choices</label>
                      </div>
                    </div>
                    <button *ngIf="populateCoreChoices"
                      [disabled]="!user.isProductAdmin || !selectedFeature"
                      pButton type="button"
                      class="p-button-raised p-button-sm ml-auto mr-4"
                      icon="pi pi-bolt"
                      (click)="applyCoreChoices()">
                      <span>Apply Core Choices</span>
                    </button>
                  </div>
                  <app-ag-grid
                    [gridOptions]="featureChoiceGridOptions"
                    [rowData]="featureChoices"
                    [rowSelection]="featureChoiceRowSelection"
                    [hasColSizeButtons]="false"
                    [hasClearFiltersButton]="false"
                    class="flex-1 min-h-0"
                  ></app-ag-grid>
                </div>
              </ng-template>
              <ng-template pTemplate>
                <div class="flex flex-col w-full h-full overflow-hidden">
                  <div class="qb-child-actions ml-4">
                    <span class="font-semibold">Products with Selected Feature Choice</span>
                  </div>
                  <app-ag-grid
                    [gridOptions]="productGridOptions"
                    [hasColSizeButtons]="false"
                    [hasClearFiltersButton]="false"
                    class="flex-1 min-h-0"
                  ></app-ag-grid>
                </div>
              </ng-template>
            </p-splitter>
          </p-tabPanel>
          <p-tabPanel header="Product Types">
            <div class="flex flex-col h-full">
              <app-ag-grid
                [gridOptions]="productTypeGridOptions"
                [hasColSizeButtons]="false"
                [hasClearFiltersButton]="false"
                class="flex-1 min-h-0"
              ></app-ag-grid>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button *ngIf="!this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-check" (click)="saveChanges()">
      <span>Save</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-undo" (click)="cancelChanges()">
      <span>Undo</span>
    </button>
  </div>
</ng-template>
